<template>
  <div class="transfer">
    <v-app>
      <div v-if="!userid && !hasCartarray">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>
            {{ $t('Not found this page') }}
          </v-alert>
        </v-container>
      </div>
      <div v-else-if="isCompleted">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart@4x.png"
              alt="shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">{{ $t('Payment Successfully') }}</p>
            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
              alt="empty shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">
              {{ $t('This order has been reset, please try to order again.') }}
            </p>

            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <div
        v-show="
          (!isEmptyShoppingCart && !isCompleted && userid) || hasCartarray
        "
      >
        <merchant-detail
          v-model="pageProfile"
          :salePageShopName="salePage ? salePage.shop_name : ''"
          :salePageIsActive="salePage ? salePage.is_active : false"
        ></merchant-detail>

        <v-layout class="mt-5" wrap row v-if="isEditAddress">
          <v-flex xs12 sm6 offset-sm3 v-if="product_detail_json">
            <edit-cart-summary
              :productDetail="product_detail_json"
              :verifyData.sync="verifyDataEditPage"
            ></edit-cart-summary>
          </v-flex>
        </v-layout>
      </div>

      <form
        id="checkout-form"
        class="checkout-form"
        method="POST"
        @submit.prevent="handleSubmit"
      >
        <v-container class="mt-5">
          <v-layout wrap row>
            <v-flex xs12 sm6 offset-sm3>
              <h3
                class="headline"
                :style="{ color: theme.color }"
                v-if="!isEditAddress"
              >
                {{ $t('Payment') }}
              </h3>
              <h3 class="headline" :style="{ color: theme.color }" v-else>
                {{ $t('Shipping Address') }}
              </h3>
              <br />

              <h3 class="mb-3">
                {{ $t('Shipping Address') }}
              </h3>
              <div v-if="shippingAddressList && shippingAddressList.length > 0">
                <v-radio-group v-model="selectedAddress">
                  <div
                    v-for="(item, index) in shippingAddressList"
                    :key="index"
                    class="mb-3 px-2 mr-0"
                    style="border: 1px solid #000; border-radius: 8px"
                  >
                    <v-card elevation="0" class="my-1" @click.stop="">
                      <v-layout wrap>
                        <v-flex xs8 style="display: flex; align-items: center">
                          <v-radio :value="item.id" :color="theme.color">
                            <template v-slot:label>
                              <div
                                class="pb-1"
                                style="font-size: 14px; color: #000"
                              >
                                <span>{{
                                  item.address ? item.address.name : ''
                                }}</span>
                                <span
                                  class="pl-1"
                                  v-if="item.address && item.address.tel"
                                  >({{ item.address.tel }})
                                </span>
                              </div>
                            </template>
                          </v-radio>
                        </v-flex>
                        <v-flex xs4 class="text-xs-right"
                          ><v-btn
                            icon
                            color="warning"
                            outline
                            small
                            class="mx-1"
                            @click="handleEditAddress(item)"
                          >
                            <v-icon small>edit</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="error"
                            outline
                            small
                            class="mx-1"
                            @click="handleDeleteAddress(item.id)"
                          >
                            <v-icon small>delete</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs12 class="pb-1" style="font-size: 14px">
                          {{ formattedCombineAddress(item.address) }}
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </div>
                </v-radio-group>
              </div>
              <div v-else class="text-xs-center">
                - ยังไม่มีที่อยู่ในการจัดส่ง กรุณาเพิ่มที่อยู่ในการจัดส่ง -
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="mb-4 text-xs-center">
                <v-btn
                  flat
                  @click="showAddressManage = true"
                  :color="theme.color"
                >
                  <v-icon>mdi-plus-circle-outline </v-icon>&nbsp;
                  <span>{{ $t('add_shipping_address') }}</span>
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3>
              <template
                v-if="
                  pageProfile &&
                  pageProfile.pageid &&
                  shippinglist &&
                  !isOoca &&
                  pageProfile.type != 'nvbb'
                "
              >
                <shipping-type
                  v-show="!isNestle"
                  :customerShippingPrice="customerShippingPrice"
                  :bearhouseshippingprice="bearhouseshippingprice"
                  :cdsshippingprice="cdsshippingprice"
                  v-model="shippingType"
                  @onChange="changeShippingType"
                  :shippinglist="shippinglist"
                  :additionalproduct_charge="additionalproduct_charge"
                  :pageid="pageProfile.pageid"
                  :total="billing_subtotal"
                  :key="timestamp"
                  :weight="weight"
                  :salePageActive="salePage ? salePage.is_active : false"
                  :quantityType="quantityType"
                  :transportlists="transport_lists"
                ></shipping-type>
              </template>
            </v-flex>
          </v-layout>
        </v-container>
        <v-divider v-if="!isEditAddress"></v-divider>
        <v-container
          class="mt-3"
          v-if="
            !isEditAddress ||
            (product_detail_json &&
              product_detail_json.created_by.includes('admin'))
          "
        >
          <v-layout wrap row>
            <v-flex xs12 sm6 offset-sm3>
              <template
                v-if="
                  !isEditAddress ||
                  (product_detail_json &&
                    !product_detail_json.created_by.includes('admin') &&
                    product_detail_json.status === 'pending')
                "
              >
                <h3
                  class="headline mb-3 text-xs-center"
                  :style="{ color: theme.color }"
                >
                  <template v-if="$store.getters.isPowerBuyPage">
                    รายละเอียดสินค้าที่สนใจ
                  </template>
                  <template v-else>
                    {{ $t('Payment Detail') }}
                  </template>
                </h3>
                <cart-summary
                  :key="`cartsummary_${timestamp}`"
                  :customerShippingPrice="customerShippingPrice"
                  :notShipping="notShipping"
                  :cdsshippingprice="cdsshippingprice"
                  :bearhouseshippingprice="bearhouseshippingprice"
                  :total="billing_total"
                  :totalincludediscount="billing_subtotal"
                  :discount="discount"
                  :voucher="voucher"
                  :shippingType="shippingType"
                  :additionalproduct_charge="additionalproduct_charge"
                  :exceptCashOnDelivery="exceptCashOnDelivery"
                  :transportCode="transport_code"
                  :transportCost="transport_cost"
                  :ableToBuy="ableToBuy"
                  :zipCode="shippingAddress2.zipcode"
                ></cart-summary>

                <template>
                  <template
                    v-if="
                      !loading && pageProfile.egg_crm_status
                        ? true
                        : !['485851741439218'].includes(pageProfile.pageid)
                    "
                  >
                    <div v-if="$route.query.shoptoken && hasVoucher">
                      <v-btn
                        style="width: 45%"
                        small
                        :outline="!isVoucherCode"
                        :color="theme.color"
                        :disabled="discount === fixDiscount"
                        @click="isVoucherCode = true"
                      >
                        <span :style="isVoucherCode ? 'color:#fff' : ''">{{
                          $t('voucher_code')
                        }}</span>
                      </v-btn>

                      <v-btn
                        style="width: 45%"
                        small
                        :outline="isVoucherCode"
                        :color="theme.color"
                        @click="isVoucherCode = false"
                        :disabled="voucher !== null"
                      >
                        <span :style="!isVoucherCode ? 'color:#fff' : ''">
                          {{ $t('Discount') }}</span
                        >
                      </v-btn>
                    </div>
                    <template
                      v-if="isVoucherCode && !loadingVoucher && hasVoucher"
                    >
                      <voucher-code-input
                        :shippingType="shippingType"
                        v-model="voucherCode"
                        @onUpdateTotal="onUpdateTotal"
                        :totalEgg="billing_total"
                        :exceptCashOnDelivery="exceptCashOnDelivery"
                        :selectedGiveAwayProduct="selectedGiveAwayProduct"
                        @handleSelectedGiveAwayProduct="
                          handleSelectedGiveAwayProduct
                        "
                      >
                        <template v-slot:append="{ hasGiveAways }">
                          <input
                            name="selectedGiveAwayProduct"
                            data-vv-as="ของแถม"
                            placeholder="ของแถม"
                            type="hidden"
                            v-model="selectedGiveAwayProduct"
                            v-validate="hasGiveAways ? 'required' : ''"
                          />
                          <div class="red--text">
                            {{
                              errors.has('selectedGiveAwayProduct')
                                ? 'กรุณาเลือกของแถม'
                                : ''
                            }}
                          </div>
                        </template>
                      </voucher-code-input>
                    </template>
                    <template v-else>
                      <v-layout v-if="$route.query.shoptoken">
                        <v-flex>
                          <div
                            :class="{
                              'has-error': errors.has('input_discount')
                            }"
                            class="mb-1"
                          >
                            <v-text-field
                              outline
                              :label="$t('input_discount')"
                              name="input_discount"
                              :data-vv-as="$t('Discount')"
                              :color="theme.color"
                              v-model="fixDiscount"
                              maxlength="20"
                              v-validate="{
                                numeric: true
                              }"
                              light
                              :error="
                                errors.has('input_discount') ? true : false
                              "
                              :error-messages="
                                errors.has('input_discount')
                                  ? errors.first('input_discount')
                                  : ''
                              "
                            ></v-text-field>
                          </div>
                        </v-flex>
                        <v-flex shrink>
                          <v-btn
                            v-if="discount === fixDiscount"
                            outline
                            @click="
                              fixDiscount = null
                              onUpdateTotal(null)
                            "
                            color="red"
                          >
                            {{ $t('ยกเลิก') }}
                          </v-btn>
                          <v-btn
                            v-else
                            style="color: #ffffff"
                            @click="onUpdateTotal(null)"
                            :color="theme.color"
                          >
                            {{ $t('use_discount') }}
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </template>
                  </template>
                </template>

                <v-layout
                  v-if="
                    chooseShippingType === 'lalamove' &&
                    !['cityfresh'].includes(pageProfile.type) &&
                    !$store.getters.isPowerBuyPage
                  "
                >
                  <v-flex class="mr-1">
                    <v-btn
                      :color="theme.color"
                      dark
                      block
                      small
                      @click="
                        lalamove.cod = false
                        gmapLocation()
                      "
                      :outline="lalamove.cod"
                    >
                      <v-icon small class="mr-2">mdi-cash-multiple</v-icon>
                      {{ $t('transfer') }}
                    </v-btn>
                  </v-flex>
                  <v-flex class="ml-1">
                    <v-btn
                      :color="theme.color"
                      dark
                      small
                      block
                      @click="selectCODLalamove"
                      :outline="!lalamove.cod"
                    >
                      <v-icon small class="mr-2"
                        >mdi-package-variant-closed</v-icon
                      >
                      {{ $t('cod_charge') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
                <div
                  v-if="
                    !$store.state.cds.includes(pageid) &&
                    pageProfile.type != 'nestle' &&
                    !$store.getters.isPowerBuyPage
                  "
                  :class="{ 'has-error': errors.has('remark') }"
                  style="margin-bottom: 15px"
                >
                  <v-textarea
                    outline
                    :label="
                      $t('Remark') +
                      (pageProfile.type == 'alice'
                        ? ' (ระบุเวลารับสินค้า/จุดสังเกตที่อยู่/รายละเอียดการจัดสินค้าเพิ่มเติ่ม)'
                        : '')
                    "
                    name="remark"
                    rows="5"
                    :data-vv-as="$t('Remark')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                    hide-details
                  ></v-textarea>
                </div>
              </template>

              <div
                v-if="
                  !product_detail_json ||
                  (product_detail_json &&
                    product_detail_json.status === 'pending')
                "
              >
                <div style="padding-bottom: 25px">
                  <v-card>
                    <v-card-text>
                      <div>
                        <v-layout
                          row
                          wrap
                          class="mb-3"
                          v-if="!lalamove.cod && !$route.query.shoptoken"
                        >
                          <DefaultPaymentButton
                            v-if="paymentList.includes('gbprime')"
                            :paymentList="paymentList"
                            :transferType="transferType"
                            :type="'qrcode'"
                            @handleClick="
                              transferType = 'qrcode'
                              setShippingDefault()
                            "
                          >
                            <v-icon small class="mr-2">
                              mdi-qrcode-scan
                            </v-icon>
                            QR CODE
                          </DefaultPaymentButton>
                          <DefaultPaymentButton
                            v-if="
                              paymentList.includes('gbprime_mobile_banking')
                            "
                            :disabled="totalPrice < 20"
                            :paymentList="paymentList"
                            :transferType="transferType"
                            :type="'gbprime_mobile_banking'"
                            @handleClick="
                              transferType = 'gbprime_mobile_banking'
                              setShippingDefault()
                            "
                          >
                            <v-icon small class="mr-2">
                              mdi-cash-multiple
                            </v-icon>
                            MOBILE BANKING
                          </DefaultPaymentButton>
                          <DefaultPaymentButton
                            v-if="
                              paymentList.includes('transfer') &&
                              !showOnlyQRpage
                            "
                            :paymentList="paymentList"
                            :transferType="transferType"
                            :type="'transfer'"
                            @handleClick="
                              transferType = 'transfer'
                              setShippingDefault()
                            "
                          >
                            <v-icon small class="mr-2">
                              mdi-cash-multiple
                            </v-icon>
                            {{ $t('transfer') }}
                          </DefaultPaymentButton>

                          <template
                            v-if="
                              $store.state.page2c2p.includes(pageid) &&
                              !['tero'].includes(pageProfile.type)
                            "
                          >
                            <DefaultPaymentButton
                              v-if="paymentList.includes('2c2p')"
                              :paymentList="paymentList"
                              :transferType="transferType"
                              :type="'2c2p'"
                              @handleClick="
                                transferType = '2c2p'
                                setShippingDefault()
                              "
                            >
                              <template>
                                <v-icon small class="mr-2"
                                  >mdi-credit-card</v-icon
                                >
                                <template
                                  v-if="
                                    pageProfile && pageProfile.type == 'nestle'
                                  "
                                >
                                  {{ $t('Payment') }}
                                </template>
                                <template
                                  v-else-if="
                                    [
                                      '104716585038207',
                                      '362065616073'
                                    ].includes(pageProfile.pageid) ||
                                    ['tero'].includes(pageProfile.type)
                                  "
                                >
                                  {{ $t('Credit Cards') }}
                                </template>
                                <template v-else>
                                  {{ $t('2C2P Payment') }}
                                </template>
                              </template>
                            </DefaultPaymentButton>
                          </template>
                          <template v-else>
                            <DefaultPaymentButton
                              v-if="paymentList.includes('2c2p')"
                              :paymentList="paymentList"
                              :transferType="transferType"
                              :type="'fbpay'"
                              @handleClick="
                                transferType = 'fbpay'
                                setShippingDefault()
                              "
                            >
                              <v-icon small class="mr-2"
                                >mdi-credit-card</v-icon
                              >
                              {{ $t('Credit Cards') }}
                            </DefaultPaymentButton>
                          </template>

                          <DefaultPaymentButton
                            v-if="paymentList.includes('fbpay') && userid"
                            :paymentList="paymentList"
                            :transferType="transferType"
                            :type="'fbpay'"
                            @handleClick="
                              transferType = 'fbpay'
                              setShippingDefault()
                            "
                          >
                            <v-icon small class="mr-2">
                              mdi-cellphone-android
                            </v-icon>
                            {{ $t('Mobile Banking') }}
                          </DefaultPaymentButton>

                          <DefaultPaymentButton
                            v-if="paymentList.includes('cod') && userid"
                            :paymentList="paymentList"
                            :transferType="transferType"
                            :type="'cod_charge'"
                            @handleClick="
                              transferType = 'cod_charge'
                              setShippingDefault('cod_charge')
                            "
                          >
                            <v-icon small class="mr-2">
                              mdi-package-variant-closed
                            </v-icon>
                            {{ $t('cod_charge') }}
                          </DefaultPaymentButton>

                          <DefaultPaymentButton
                            v-if="paymentList.includes('paypal') && userid"
                            :paymentList="paymentList"
                            :transferType="transferType"
                            :type="'paypal'"
                            @handleClick="
                              transferType = 'paypal'
                              renderPaypalBtn()
                              setShippingDefault()
                            "
                          >
                            <v-icon small class="mr-2">mdi-credit-card</v-icon>
                            {{ $t('PayPal') }}
                          </DefaultPaymentButton>

                          <DefaultPaymentButton
                            v-if="
                              paymentList.includes('creditgbprime') && userid
                            "
                            :paymentList="paymentList"
                            :transferType="transferType"
                            :type="'creditgbprime'"
                            @handleClick="
                              transferType = 'creditgbprime'
                              setShippingDefault()
                            "
                          >
                            <v-icon small class="mr-2">mdi-credit-card</v-icon>
                            {{ $t('Credit Cards') }}
                          </DefaultPaymentButton>
                        </v-layout>

                        <v-layout
                          v-if="
                            ['gbprime_mobile_banking'].includes(transferType)
                          "
                          row
                          wrap
                        >
                          <v-flex>
                            <label
                              class="my-1"
                              style="
                                font-weight: bold;
                                color: #555;
                                font-size: 1.1rem;
                              "
                              >Select Bank</label
                            >
                            <v-radio-group v-model="gbFormData.bankCode">
                              <v-radio
                                v-for="(item, index) in gbBank"
                                :key="`bank-option-${index}`"
                                :label="item.text"
                                :value="item.value"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>

                        <PaymentInfo :pageProfile="pageProfile" />

                        <p
                          class="text-xs-center"
                          v-if="
                            ['qrcode', 'gbprime_mobile_banking'].includes(
                              transferType
                            )
                          "
                        >
                          {{
                            $t(
                              'If paying by QR Code, please click the button {proceed_payment}” at the bottom.',
                              {
                                proceed_payment: isNestle
                                  ? 'ทำการสั่งซื้อ'
                                  : $store.getters.isPowerBuyPage
                                  ? 'ติดต่อแอดมิน'
                                  : $route.query.shoptoken
                                  ? $t('Proceed Payment1')
                                  : $t('Proceed Payment')
                              }
                            )
                          }}
                        </p>

                        <!-- Cash on Delivery -->
                        <template
                          v-if="
                            (shippingType &&
                              shippingType.type == 'cod_charge') ||
                            lalamove.cod
                          "
                        >
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t(
                                  'By clicking {proceed_payment}, Ive read and',
                                  {
                                    proceed_payment: isNestle
                                      ? 'ทำการสั่งซื้อ'
                                      : $store.getters.isPowerBuyPage
                                      ? 'ติดต่อแอดมิน'
                                      : $route.query.shoptoken
                                      ? $t('Proceed Payment1')
                                      : $t('Proceed Payment')
                                  }
                                )
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>
                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div class="text-xs-center">
                              <v-btn
                                dark
                                :color="theme.color"
                                :disabled="
                                  loading ||
                                  isCartOutOfStock ||
                                  !selectedAddress
                                "
                                @click="handleSubmit"
                                :loading="pageLoading || loadingMapInfo"
                                v-if="!isCompletePayment"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{
                                  isNestle
                                    ? 'ทำการสั่งซื้อ'
                                    : $store.getters.isPowerBuyPage
                                    ? 'ติดต่อแอดมิน'
                                    : $route.query.shoptoken
                                    ? $t('Proceed Payment1')
                                    : $t('Proceed Payment')
                                }}
                              </v-btn>
                            </div>
                          </template>
                        </template>

                        <template
                          v-else-if="
                            [
                              'transfer',
                              'fbpay',
                              'gbprime_mobile_banking'
                            ].includes(transferType)
                          "
                        >
                          <div
                            v-if="
                              ['transfer'].includes(transferType) &&
                              !$route.query.shoptoken
                            "
                          >
                            <div
                              class="mb-4"
                              v-if="!$store.getters.isPowerBuyPage"
                            >
                              <template v-if="banktransferinfo_photo">
                                <img
                                  :src="banktransferinfo_photo"
                                  alt="bank transfer"
                                  style="
                                    border: 1px solid #eee;
                                    border-radius: 5px;
                                    margin-bottom: 15px;
                                    width: 100%;
                                  "
                                />
                              </template>
                              <template v-if="banktransferinfo">
                                <bank-number
                                  :text="banktransferinfo"
                                ></bank-number>
                              </template>
                            </div>

                            <div
                              :class="{
                                'has-error': errors.has('paymentSlipImage')
                              }"
                              class="mb-4"
                              v-if="
                                !shippingType ||
                                (shippingType &&
                                  shippingType.type != 'cod_charge' &&
                                  !$store.getters.isPowerBuyPage)
                              "
                            >
                              <h3
                                class="headline"
                                :style="{ color: theme.color }"
                              >
                                {{ $t('Payment slip') }}
                              </h3>
                              <br />
                              <template v-if="!isCartOutOfStock">
                                <upload-file
                                  :outputtype="
                                    isCDS || pageProfile.type == 'monobo'
                                      ? 'base64'
                                      : 'url'
                                  "
                                  name="paymentSlipImage"
                                  v-validate="
                                    ((payment_slip_status === true ||
                                      payment_slip_status === 'true') &&
                                      !hasCartarray) ||
                                    $route.query.shoptoken
                                      ? ''
                                      : 'required'
                                  "
                                  :data-vv-as="$t('Payment Slip Image')"
                                  v-model="paymentSlipImage"
                                  :verifyData.sync="verifyData"
                                ></upload-file>

                                <template
                                  v-if="payment_slip_status && !hasCartarray"
                                >
                                  <v-alert
                                    :value="true"
                                    color="info"
                                    icon="info"
                                    outline
                                  >
                                    {{ $t('slip_later_remark') }}
                                  </v-alert>
                                </template>
                              </template>
                              <p
                                class="caption ma-2"
                                style="color: red"
                                v-show="errors.has('paymentSlipImage')"
                              >
                                {{ errors.first('paymentSlipImage') }}
                              </p>
                            </div>
                          </div>
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t(
                                  'By clicking {proceed_payment}, Ive read and',
                                  {
                                    proceed_payment: isNestle
                                      ? 'ทำการสั่งซื้อ'
                                      : $store.getters.isPowerBuyPage
                                      ? 'ติดต่อแอดมิน'
                                      : $route.query.shoptoken
                                      ? $t('Proceed Payment1')
                                      : $t('Proceed Payment')
                                  }
                                )
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>

                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>
                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <p
                              v-if="notShipping"
                              style="color: red"
                              class="text-xs-center"
                            >
                              ไม่สามารถจัดส่งนอกพื้นที่ได้
                            </p>
                            <p
                              v-else-if="notReachMinimum"
                              style="color: red"
                              class="text-xs-center"
                            >
                              {{
                                $t('Please order a minimum amount of 500 baht.')
                              }}
                            </p>
                            <div v-else class="text-xs-center">
                              <v-btn
                                id="proceedPayment"
                                class="white--text"
                                :color="theme.color"
                                :disabled="loading || isCartOutOfStock"
                                @click="handleSubmit"
                                :loading="pageLoading || loadingLalamove"
                                v-if="!isCompletePayment"
                                style="min-width: 150px"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{
                                  isNestle
                                    ? 'ทำการสั่งซื้อ'
                                    : $store.getters.isPowerBuyPage
                                    ? 'ติดต่อแอดมิน'
                                    : $route.query.shoptoken
                                    ? $t('Proceed Payment1')
                                    : $t('Proceed Payment')
                                }}
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <template v-else-if="['2c2p'].includes(transferType)">
                          <template
                            v-if="
                              ['104716585038207', '362065616073'].includes(
                                pageProfile.pageid
                              ) || ['tero', 'nestle'].includes(pageProfile.type)
                            "
                          >
                            <form
                              ref="form2c2p"
                              id="2c2p-payment-form"
                              method="POST"
                              :action="`https://2c2pgateway.zwiz.ai/indexzwiz.php?date=${new Date()}`"
                            >
                              <input
                                type="hidden"
                                v-model="orderid"
                                name="orderid"
                              />
                              <input
                                type="hidden"
                                :value="totalPrice ? totalPrice * 100 : 0"
                                name="amount"
                              />
                              <input type="hidden" value="bec" name="theme" />
                              <input
                                type="hidden"
                                :value="pageProfile.pageid"
                                name="pageid"
                              />
                              <input
                                type="hidden"
                                v-model="serverUrl"
                                name="serverUrl"
                              />
                              <input
                                type="hidden"
                                :value="payment_option"
                                name="payment_option"
                              />
                            </form>
                          </template>

                          <div v-else>
                            <v-card>
                              <v-card-text>
                                <form
                                  @submit="submit2c2p"
                                  ref="form2c2p"
                                  id="2c2p-payment-form"
                                  method="POST"
                                  :action="`https://2c2pgateway.zwiz.ai/index.php?${new Date()}`"
                                >
                                  <div
                                    :class="{
                                      'has-error': errors.has('Cardholdername')
                                    }"
                                    class="mb-1"
                                  >
                                    <v-text-field
                                      name="Cardholdername"
                                      :data-vv-as="$t('Cardholder Name')"
                                      label="Cardholder Name"
                                      :color="theme.color"
                                      v-model="creditcard.name"
                                      placeholder=" "
                                      v-validate="'required'"
                                      :error="
                                        errors.has('Cardholdername')
                                          ? true
                                          : false
                                      "
                                      :error-messages="
                                        errors.has('Cardholdername')
                                          ? errors.first('Cardholdername')
                                          : ''
                                      "
                                    ></v-text-field>
                                  </div>
                                  <div
                                    :class="{
                                      'has-error': errors.has('cardnumber')
                                    }"
                                    class="mb-1"
                                  >
                                    <v-text-field
                                      data-encrypt="cardnumber"
                                      name="cardnumber"
                                      label="Card Number"
                                      placeholder=" "
                                      v-validate="'required'"
                                      :error="
                                        errors.has('cardnumber') ? true : false
                                      "
                                      :error-messages="
                                        errors.has('cardnumber')
                                          ? errors.first('cardnumber')
                                          : ''
                                      "
                                      :color="theme.color"
                                      v-model="creditcard.number"
                                    ></v-text-field>
                                  </div>
                                  <v-layout>
                                    <v-flex xs6>
                                      <div
                                        class="form-control"
                                        :class="{
                                          'has-error':
                                            errors.has('month') ||
                                            errors.has('year')
                                        }"
                                      >
                                        <v-text-field
                                          label="Expire date"
                                          v-themask="'##/##'"
                                          :masked="true"
                                          :error="
                                            errors.has('month') ||
                                            errors.has('year')
                                          "
                                          :error-messages="
                                            errors.has('month')
                                              ? errors.first('month')
                                              : errors.has('year')
                                              ? errors.first('month')
                                              : ''
                                          "
                                          placeholder="MM/YY"
                                          :color="theme.color"
                                          @input="onChangeExpireDate"
                                          name="expiredate"
                                          v-model="creditcard.validate"
                                        />

                                        <v-text-field
                                          data-encrypt="month"
                                          name="month"
                                          :data-vv-as="'Month'"
                                          style="width: 0; height: 0"
                                          v-validate="'required'"
                                          readonly
                                          class="pa-0"
                                          v-model="creditcard.expiremonth"
                                        />
                                        <v-text-field
                                          name="year"
                                          data-encrypt="year"
                                          class="pa-0"
                                          :data-vv-as="'Year'"
                                          v-validate="'required'"
                                          style="
                                            visibility: hidden;
                                            width: 0;
                                            height: 0;
                                          "
                                          readonly
                                          v-model="creditcard.expireyear"
                                        />
                                      </div>
                                    </v-flex>
                                    <v-flex xs6>
                                      <div
                                        :class="{
                                          'has-error': errors.has('cvv')
                                        }"
                                      >
                                        <v-text-field
                                          label="CVV/CVV2"
                                          v-validate="'required'"
                                          :data-vv-as="'CVV/CVV2'"
                                          data-encrypt="cvv"
                                          name="cvv"
                                          v-themask="['###', '####']"
                                          placeholder=" "
                                          :color="theme.color"
                                          v-model="creditcard.cvv"
                                          :error="
                                            errors.has('cvv') ? true : false
                                          "
                                          :error-messages="
                                            errors.has('cvv')
                                              ? errors.first('cvv')
                                              : ''
                                          "
                                        />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <input
                                    type="hidden"
                                    v-model="orderid"
                                    name="orderid"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="amount"
                                    name="amount"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="facebookname"
                                    name="facebookname"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="pageid"
                                    name="pageid"
                                  />
                                </form>
                              </v-card-text>
                              <div class="pb-3 text-xs-center">
                                <img
                                  width="120px"
                                  src="@/assets/img/creditcardlogo.png"
                                />
                              </div>
                            </v-card>
                          </div>
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t(
                                  'By clicking {proceed_payment}, Ive read and',
                                  {
                                    proceed_payment: isNestle
                                      ? 'ทำการสั่งซื้อ'
                                      : $store.getters.isPowerBuyPage
                                      ? 'ติดต่อแอดมิน'
                                      : $route.query.shoptoken
                                      ? $t('Proceed Payment1')
                                      : $t('Proceed Payment')
                                  }
                                )
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>

                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div
                              class="text-xs-center"
                              v-if="!isCompletePayment"
                            >
                              <v-btn
                                v-if="isCDS && transferType == '2c2p'"
                                dark
                                :color="theme.color"
                                :disabled="
                                  loading ||
                                  isCartOutOfStock ||
                                  !selectedAddress
                                "
                                @click="handleSubmit"
                                :loading="pageLoading"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{
                                  isNestle
                                    ? 'ทำการสั่งซื้อ'
                                    : $store.getters.isPowerBuyPage
                                    ? 'ติดต่อแอดมิน'
                                    : $route.query.shoptoken
                                    ? $t('Proceed Payment1')
                                    : $t('Proceed Payment')
                                }}
                              </v-btn>
                              <v-btn
                                dark
                                v-else
                                :color="theme.color"
                                :disabled="
                                  loading ||
                                  isCartOutOfStock ||
                                  !selectedAddress
                                "
                                @click="handleSubmit"
                                :loading="pageLoading"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{
                                  isNestle
                                    ? 'ทำการสั่งซื้อ'
                                    : $store.getters.isPowerBuyPage
                                    ? 'ติดต่อแอดมิน'
                                    : $route.query.shoptoken
                                    ? $t('Proceed Payment1')
                                    : $t('Proceed Payment')
                                }}
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <template
                          v-else-if="['creditgbprime'].includes(transferType)"
                        >
                          <div>
                            <v-card class="elevation-0">
                              <v-card-text>
                                <form
                                  ref="form-gbcredit"
                                  id="gbcredit-payment-form"
                                  method="POST"
                                >
                                  <div
                                    :class="{
                                      'has-error': errors.has('Cardholdername')
                                    }"
                                    class="mb-1"
                                  >
                                    <v-text-field
                                      name="Cardholdername"
                                      :data-vv-as="$t('Cardholder Name')"
                                      label="Cardholder Name"
                                      :color="theme.color"
                                      v-model="creditcard.name"
                                      maxlength="120"
                                      placeholder=" "
                                      v-validate="'required'"
                                      :error="
                                        errors.has('Cardholdername')
                                          ? true
                                          : false
                                      "
                                      :error-messages="
                                        errors.has('Cardholdername')
                                          ? errors.first('Cardholdername')
                                          : ''
                                      "
                                    ></v-text-field>
                                  </div>
                                  <div
                                    :class="{
                                      'has-error': errors.has('cardnumber')
                                    }"
                                    class="mb-1"
                                  >
                                    <v-text-field
                                      data-encrypt="cardnumber"
                                      name="cardnumber"
                                      v-themask="'#### #### #### #### ###'"
                                      label="Card Number"
                                      placeholder=" "
                                      v-validate="'required|credit_card'"
                                      :error="
                                        errors.has('cardnumber') ? true : false
                                      "
                                      :error-messages="
                                        errors.has('cardnumber')
                                          ? errors.first('cardnumber')
                                          : ''
                                      "
                                      :color="theme.color"
                                      v-model="creditcard.number"
                                    ></v-text-field>
                                  </div>
                                  <v-layout>
                                    <v-flex xs6 class="pr-1">
                                      <div
                                        class="form-control"
                                        :class="{
                                          'has-error':
                                            errors.has('month') ||
                                            errors.has('year')
                                        }"
                                      >
                                        <v-text-field
                                          label="Expire date"
                                          v-themask="'##/##'"
                                          :masked="true"
                                          :error="
                                            errors.has('month') ||
                                            errors.has('year')
                                          "
                                          :error-messages="
                                            errors.has('month')
                                              ? errors.first('month')
                                              : errors.has('year')
                                              ? errors.first('month')
                                              : ''
                                          "
                                          placeholder="MM/YY"
                                          :color="theme.color"
                                          @input="onChangeExpireDate"
                                          name="expiredate"
                                          v-model="creditcard.validate"
                                        />

                                        <v-text-field
                                          data-encrypt="month"
                                          name="month"
                                          :data-vv-as="'Month'"
                                          style="width: 0; height: 0"
                                          v-validate="'required'"
                                          readonly
                                          class="pa-0"
                                          v-model="creditcard.expiremonth"
                                        />
                                        <v-text-field
                                          name="year"
                                          data-encrypt="year"
                                          class="pa-0"
                                          :data-vv-as="'Year'"
                                          v-validate="'required'"
                                          style="
                                            visibility: hidden;
                                            width: 0;
                                            height: 0;
                                          "
                                          readonly
                                          v-model="creditcard.expireyear"
                                        />
                                      </div>
                                    </v-flex>
                                    <v-flex xs6 class="pl-1">
                                      <div
                                        :class="{
                                          'has-error': errors.has('cvv')
                                        }"
                                      >
                                        <v-text-field
                                          label="CVV/CVV2"
                                          v-validate="'required'"
                                          :data-vv-as="'CVV/CVV2'"
                                          data-encrypt="cvv"
                                          name="cvv"
                                          v-themask="['###', '####']"
                                          placeholder=" "
                                          :color="theme.color"
                                          v-model="creditcard.cvv"
                                          :error="
                                            errors.has('cvv') ? true : false
                                          "
                                          :error-messages="
                                            errors.has('cvv')
                                              ? errors.first('cvv')
                                              : ''
                                          "
                                        />
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <input
                                    type="hidden"
                                    v-model="orderid"
                                    name="orderid"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="amount"
                                    name="amount"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="facebookname"
                                    name="facebookname"
                                  />
                                  <input
                                    type="hidden"
                                    v-model="pageid"
                                    name="pageid"
                                  />
                                </form>
                              </v-card-text>
                              <div class="pb-3 text-xs-center">
                                <img
                                  width="120px"
                                  src="@/assets/img/creditcardlogo.png"
                                />
                              </div>
                            </v-card>
                          </div>
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t(
                                  'By clicking {proceed_payment}, Ive read and',
                                  {
                                    proceed_payment: isNestle
                                      ? 'ทำการสั่งซื้อ'
                                      : $store.getters.isPowerBuyPage
                                      ? 'ติดต่อแอดมิน'
                                      : $route.query.shoptoken
                                      ? $t('Proceed Payment1')
                                      : $t('Proceed Payment')
                                  }
                                )
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>

                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div class="text-xs-center">
                              <v-btn
                                dark
                                :color="theme.color"
                                :disabled="
                                  loading ||
                                  isCartOutOfStock ||
                                  !selectedAddress
                                "
                                @click="gbcreditSubmit"
                                :loading="pageLoading"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{
                                  isNestle
                                    ? 'ทำการสั่งซื้อ'
                                    : $store.getters.isPowerBuyPage
                                    ? 'ติดต่อแอดมิน'
                                    : $route.query.shoptoken
                                    ? $t('Proceed Payment1')
                                    : $t('Proceed Payment')
                                }}
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <template v-else-if="['qrcode'].includes(transferType)">
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t(
                                  'By clicking {proceed_payment}, Ive read and',
                                  {
                                    proceed_payment: isNestle
                                      ? 'ทำการสั่งซื้อ'
                                      : $store.getters.isPowerBuyPage
                                      ? 'ติดต่อแอดมิน'
                                      : $route.query.shoptoken
                                      ? $t('Proceed Payment1')
                                      : $t('Proceed Payment')
                                  }
                                )
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>

                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>
                          <template v-else>
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div class="text-xs-center">
                              <v-btn
                                :dark="
                                  !(
                                    loading ||
                                    isCartOutOfStock ||
                                    !selectedAddress
                                  )
                                "
                                :color="theme.color"
                                :disabled="
                                  loading ||
                                  isCartOutOfStock ||
                                  !selectedAddress
                                "
                                @click="qrHandleSubmit"
                                :loading="pageLoading || loadingQrcode"
                              >
                                <v-icon class="mr-2">mdi-cart-outline</v-icon>
                                {{
                                  isNestle
                                    ? 'ทำการสั่งซื้อ'
                                    : $store.getters.isPowerBuyPage
                                    ? 'ติดต่อแอดมิน'
                                    : $route.query.shoptoken
                                    ? $t('Proceed Payment1')
                                    : $t('Proceed Payment')
                                }}
                              </v-btn>
                            </div>
                          </template>
                        </template>
                        <div v-show="['paypal'].includes(transferType)">
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t(
                                  'By clicking {proceed_payment}, Ive read and',
                                  {
                                    proceed_payment: isNestle
                                      ? 'ทำการสั่งซื้อ'
                                      : $store.getters.isPowerBuyPage
                                      ? 'ติดต่อแอดมิน'
                                      : $route.query.shoptoken
                                      ? $t('Proceed Payment1')
                                      : $t('Proceed Payment')
                                  }
                                )
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>

                          <template v-if="loading">
                            <div class="text-xs-center my-3">
                              <v-progress-circular
                                :key="theme.color"
                                indeterminate
                                :color="theme.color"
                              ></v-progress-circular>
                            </div>
                          </template>
                          <div v-show="!loading">
                            <p
                              class="text-xs-center"
                              style="color: red"
                              v-if="isCartOutOfStock"
                            >
                              {{
                                $t(
                                  'Not enough products in stock, please try to order again.'
                                )
                              }}.
                            </p>
                            <div
                              ref="paypal-button-container"
                              class="text-xs-center"
                              v-show="!isCartOutOfStock"
                            >
                              <div id="paypal-button"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
        <div
          class="text-xs-center"
          v-if="
            isEditAddress &&
            !$route.query.shoptoken &&
            product_detail_json &&
            (product_detail_json.status === 'paid' ||
              product_detail_json.status === 'ordered' ||
              product_detail_json.status === 'pending')
          "
          style="margin-top: -30px; margin-bottom: 20px"
        >
          <v-btn
            dark
            :color="theme.color"
            :disabled="loading"
            @click="editAddressSubmit"
            :loading="pageLoading"
          >
            <v-icon class="mr-2">mdi-cart-outline</v-icon>
            {{ $t('editSubmit') }}
          </v-btn>
        </div>
      </form>
    </v-app>
    <Loading :payment="paymentLoading" v-if="!pageLoading && loading"></Loading>
    <term-and-condition
      :pageid="pageProfile.pageid"
      v-if="showTerm"
      @close="close()"
    ></term-and-condition>

    <v-dialog v-model="showAddressManage" max-width="600" persistent>
      <v-card class="pa-3">
        <ShippingAddressManage
          :showmap="showmap"
          v-if="showAddressManage"
          v-model="selectedEditAddress"
          :formType="shippingFormType"
          @saveSuccess="handleSaveAddress"
          @close="showAddressManage = false"
        >
        </ShippingAddressManage>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="closeQrCode">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center mt-2">
              {{
                $t(
                  'If you already have proceeded a payment, you may close this popup window.'
                )
              }}
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>

    <form
      style="display: none"
      ref="formgbprime"
      id="mobileBankingform"
      action="https://api.gbprimepay.com/v2/mobileBanking"
      method="POST"
    >
      <div>
        <label>public_key: </label>
        <input name="publicKey" :value="gbFormData.public_key" />
      </div>

      <div>
        <label>referenceNo: </label>
        <input name="referenceNo" :value="gbFormData.referenceNo" />
      </div>

      <div>
        <label>backgroundUrl: </label>
        <input
          name="backgroundUrl"
          :value="`${gbFormData.backgroundUrl}?userid=${userid}&pageid=${pageid}`"
        />
      </div>

      <div>
        <label>responseUrl: </label>
        <input name="responseUrl" :value="gbFormData.responseUrl" />
      </div>
      <div>
        <label>Amount: </label>
        <input
          type="number"
          name="amount"
          maxlength="13"
          placeholder="Amount"
          :value="gbFormData.amount"
        />
      </div>
      <div>
        <label>Bank Code: </label>
        <input name="bankCode" :value="gbFormData.bankCode" />
      </div>
      <div>
        <label>Checksum: </label>
        <input type="text" name="checksum" :value="gbFormData.hash" />
      </div>
    </form>

    <template v-if="gbcharge">
      <form
        ref="gbchargeform"
        name="form"
        :action="`${gbpath}/v1/tokens/3d_secured`"
        method="POST"
      >
        publicKey:
        <input type="text" name="publicKey" :value="gbpublickey" /><br />
        gbpReferenceNo:
        <input
          type="text"
          name="gbpReferenceNo"
          :value="gbcharge.gbpReferenceNo"
        />
      </form>
    </template>

    <v-dialog v-model="successDialog" persistent max-width="400px">
      <v-card>
        <div
          class="pointer"
          style="position: absolute; right: 0px; padding: 6px"
        >
          <v-icon v-if="countDown === 0" @click="Confirm">mdi-close</v-icon>
          <small v-else>{{ countDown }} {{ $t('second') }}</small>
        </div>
        <v-card-title
          style="
            place-content: center;
            display: block;
            text-align: -webkit-center;
          "
        >
          <v-icon style="font-size: 115px" :color="theme.color"
            >mdi-check-circle</v-icon
          >
          <h2 class="mb-4 mt-2">{{ $t(`Complete the transaction`) }}</h2>
          <h3 class="mt-2 mb-3 color-white">
            {{ $t(`Your order number is`) }}: {{ orderid }}
          </h3>
          <h4 class="mb-3">
            <v-icon>mdi-cellphone-screenshot </v-icon>
            {{ $t('Please take pictures for evidence.') }}
          </h4>
          <v-btn
            class="mt-3"
            v-if="countDown === 0"
            dark
            :color="theme.color"
            :disabled="loading"
            @click="Confirm"
          >
            {{ $t('Confirm') }}
          </v-btn>
        </v-card-title></v-card
      >
    </v-dialog>
  </div>
</template>

<script>
import MainTransfer from './MainTransfer'
import PaymentInfo from './PaymentInfo.vue'
import ShippingAddressManage from './ShippingAddressManage.vue'
export default {
  mixins: [MainTransfer],
  components: {
    PaymentInfo,
    ShippingAddressManage
  }
}
</script>
